<template>
	<div>
		<CustomTable
			ref="table"
			id_table="dose_actes"
			:busy.sync="table_busy"
			:hrefsRoutes="config_table_hrefs"
			primaryKey="actes_id"
			:items="actes"
		/>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"

	export default {
		name: 'DoseActes',
		mixins: [Congelation],
		props: ['dose'],
		data () {
			return {
				actes: [],
				table_busy: false,
	            config_table_hrefs: {
					'horse.horse_nom': {
						routeUniqueName: 'horseFiche',
	                    routeName: 'horseFiche',
	                    params: {
							horse_id: 'horse.horse_id'
	                    }
	                }
	            }
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.table_busy = true
				this.actes = await this.getDoseActes(this.dose.semencedose_id)
				this.table_busy = false
			},
		},

		components: {
        	CustomTable: () => import('GroomyRoot/components/Table/CustomTable')
		}
	}

</script>